"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
import type { LivescoreSport } from "@/views/livescore/utils/livescore";
import { useLabels } from "@/lib/labels/LabelsProvider";
const DEFAULT_SPORTS: LivescoreSport[] = ["football", "basketball", "tennis", "hockey", "american-football"];
interface PopularSportsSidebarProps {
  locale: string;
  sports?: LivescoreSport[];
}
export function PopularSportsSidebar(t0) {
  const $ = _c(14);
  const {
    locale,
    sports: t1
  } = t0;
  const sports = t1 === undefined ? DEFAULT_SPORTS : t1;
  const labels = useLabels();
  const t2 = labels.livescore?.sports?.title ?? "Popular Sports";
  let t3;
  if ($[0] !== t2) {
    t3 = <h3 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground px-2 mb-2">{t2}</h3>;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== labels.livescore?.sports || $[3] !== locale || $[4] !== sports) {
    let t5;
    if ($[6] !== labels.livescore?.sports || $[7] !== locale) {
      t5 = s => <li key={s}><Link prefetch={false} href={`/${locale}/livescore?sport=${s}`} className="block px-2 py-1.5 rounded-md text-sm text-foreground hover:bg-muted transition-colors">{labels.livescore?.sports?.[s] ?? s}</Link></li>;
      $[6] = labels.livescore?.sports;
      $[7] = locale;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = sports.map(t5);
    $[2] = labels.livescore?.sports;
    $[3] = locale;
    $[4] = sports;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <ul className="space-y-0.5">{t4}</ul>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <aside className="hidden md:block sticky top-below-nav-gap space-y-1">{t3}{t5}</aside>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}